<template>
  <span class="badge" v-bind:class="{ 'badge-success' : this.status === 'ok', 'badge-danger': this.status === 'error' }">
    {{translateStatus(this.status)}}
  </span>
</template>

<script>

  export default {
    props: {
      status: {
        type: String,
        required: true
      }
    },

    methods: {
      translateStatus(status) {
        if (status === 'ok') return 'Success'
        if (status === 'error') return 'Error'
        return status
      }
    }
  }
</script>
